import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PopupTrigger from "../../../../common/PopupTrigger";
import Button from "../../../../common/Button";

const ClosePopup = ( props ) => {

  const {
    children,
    ...PROPS
  } = props;

  return (
    <PopupTrigger>
      { props.children }
      <Popup { ...PROPS } />
    </PopupTrigger>
  );

};

const Popup = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { t } = useTranslation();

  const msg014Params = useMemo( () => {
    const count = answeringQuestions.data.totQstCt - ( answeringQuestions.answeringCount - 1 );
    return { correctedCount : 0 < count ? count : 0 };
  }, [ answeringQuestions.data.totQstCt, answeringQuestions.answeringCount ] );

  return (
    <div className="lp-container lc-alert lc-def m_border0">
      <div className="upper_pic" />
      <p className="lc-alert_txt font_24" dangerouslySetInnerHTML={ { __html : t( 'LC_05_20.msg014', msg014Params ) } } />
      <div className="lp-btnBox mt40">
        <Button className="btn btn-gray" onClick={ props.onHide }>{ t( 'LC_05_20.msg015' ) }</Button>
        <Button className="btn btn-blue m_w96" onClick={ props.onClose }>{ t( 'LC_05_20.msg016' ) }</Button>
      </div>
    </div>
  );

};

export default ClosePopup;
